export default __webpack_public_path__ + "static/media/AddTelegramAccount.3257de72.svg";